let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1K1Fj"), load("8hOn0"), load("xnqy2"), load("cM3gY"), load("Vt6S9")]).then(() => parcelRequire('gGO7C'));